export default "__VITE_ASSET__CUzC6nWq__"